module.exports = __webpack_public_path__ + "static/media/about3.b2979a27.jpg";